import SegmentedControl from "@/components/SegmentedControl/SegmentedControl"
import { STATE_FILTERS, STATE_FILTER_LABEL } from "@/content/status"
import type { StateFilter } from "@/content/status"

/**
 * All / Live / Complete / Draft, above any list of sessions or customers.
 *
 * A thin wrapper on `SegmentedControl` rather than its own control: the pills
 * are the same object, and the only thing that repeated across three screens was
 * this option list.
 */

interface FilterPillsProps {
  value: StateFilter
  onChange: (value: StateFilter) => void
  /** Drops a pill nothing could ever match on this screen. */
  omit?: readonly StateFilter[]
}

export default function FilterPills({ value, onChange, omit }: FilterPillsProps) {
  const options = STATE_FILTERS.filter((filter) => !omit?.includes(filter)).map((filter) => ({
    value: filter,
    label: STATE_FILTER_LABEL[filter],
  }))

  return (
    <SegmentedControl
      options={options}
      value={value}
      onChange={onChange}
      label="Filter by status"
      variant="loose"
      size="sm"
    />
  )
}
